<template>
    <div class="page-container">
        <md-dialog-prompt
          :md-active.sync="consulta"
          v-model="numeroBusca"
          md-title="Buscar Bilhete"
          md-input-placeholder="Número do Bilhete..."
          md-cancel-text="Cancelar"
          md-confirm-text="Buscar"
          @md-confirm="consultar()" />
        <md-dialog-prompt
          :md-active.sync="carregarPreAposta"
          v-model="numeroPreAposta"
          md-title="Carregar Pré-Aposta"
          md-input-placeholder="Número da Pré-Aposta..."
          md-cancel-text="Cancelar"
          md-confirm-text="Carregar"
          @md-confirm="carregar()" />
        <md-dialog-alert
          :md-active.sync="regras"
          md-title="Regulamento"
          :md-content="config.system_rules"
          md-confirm-text="Concordo"
          @md-confirm="concordoRegras()" />
      <md-dialog-alert
          :md-active.sync="alert"
          :md-content="msgAlert"
          md-confirm-text="Ok" />
        <md-app md-mode="fixed">
            <md-app-toolbar class="md-primary">
                <md-button class="md-icon-button" @click="menuVisible = !menuVisible" v-bind:class="{ hide: (loadingEvents || isResumeOpened || isDetailOpened) }">
                    <md-icon>menu</md-icon>
                </md-button>
                <md-button class="md-icon-button" @click="backHome()" v-bind:class="{ hide: (loadingEvents || !isDetailOpened || isResumeOpened) }">
                    <md-icon>arrow_back</md-icon>
                </md-button>
                <md-button class="md-icon-button" @click="toggleResume()" v-bind:class="{ hide: (loadingEvents || !isResumeOpened) }">
                    <md-icon>arrow_back</md-icon>
                </md-button>
                <div class="md-layout-item md-size-75">
                    <span v-bind:class="{ hide: (loadingEvents) }" class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
                        <!-- <img v-bind:class="{ hide: (loadingEvents || isDetailOpened) }" class="titan-logo" src="../assets/icone.png" style="width: 40px; margin-right: 5px; "> -->
                        <!--img v-bind:class="{ hide: (loadingEvents || isDetailOpened) }" class="titan-logo" src="../assets/logo_barra_superior.png" style="width: 150px;"-->
                        <span v-bind:class="{ hide: (loadingEvents) }">{{ titulo }}</span>
                    </span>
                </div>
            </md-app-toolbar>
            <md-app-drawer :md-active.sync="menuVisible">
                <md-toolbar class="md-primary" md-elevation="0" style="border-bottom: 0.8px solid white;background-color: #000000;">
                    <img class="titan-logo" :src="this.logoSite" style="margin-bottom: 5px; margin-top: 5px; margin-left: 80px;">
                </md-toolbar>

                <md-list style="padding-top: 0;">
                    <md-list-item style="cursor: pointer;" v-if="!loggedIn">
                        <md-icon style="color: white;margin-right: 0;">lock</md-icon>
                        <span class="md-list-item-text" @click="goToLogin()">Login</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer;">
                        <md-icon style="color: white;margin-right: 0;">search</md-icon>
                        <span class="md-list-item-text" @click="dialogConsulta()">Consultar Bilhete</span>
                    </md-list-item>
                    <!-- CAMBISTA -->
                    <md-list-item style="cursor: pointer; background-color: #0A2E54;" v-if="loggedIn">
                        <span class="md-list-item-text" style="font-weight: bold;">Bem Vindo, {{ cambista.nome }}</span>
                        <span class="md-list-item-text" style="color:#D7D9DA; font-weight: bold;text-align: right !important;align-items: unset;" v-if="loggedIn && limites != null">R$ {{ (limites.simples).toLocaleString('pt-BR') }} (S)</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer; background-color: #0A2E54;" v-if="loggedIn && limites != null">
                        <span class="md-list-item-text" style="font-weight: bold;"></span>
                        <span class="md-list-item-text" style="color:#D7D9DA; font-weight: bold;text-align: right !important;align-items: unset;">R$ {{ (limites.compostas).toLocaleString('pt-BR') }} (C)</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer; background-color: #0A2E54;" v-if="loggedIn">
                        <md-icon style="color: white;margin-right: 0;">move_to_inbox</md-icon>
                        <span class="md-list-item-text" @click="dialogPreAposta()">Pré-Aposta</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer; background-color: #0A2E54;" v-if="loggedIn">
                        <md-icon style="color: white;margin-right: 0;">list_alt</md-icon>
                        <span class="md-list-item-text" @click="goToMyTickets()">Bilhetes</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer; background-color: #0A2E54;" v-if="loggedIn">
                        <md-icon style="color: white;margin-right: 0;">insert_chart_outlined</md-icon>
                        <span class="md-list-item-text" @click="goToMyCashflow()">Caixa</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer; background-color: #0A2E54;" v-if="loggedIn">
                        <md-icon style="color: white;margin-right: 0;">exit_to_app</md-icon>
                        <span class="md-list-item-text" @click="logout()">Sair</span>
                    </md-list-item>
                    <!-- FIM CAMBISTA -->
                    <md-list-item style="cursor: pointer;">
                        <md-icon style="color: orange;margin-right: 0;">android</md-icon>
                        <span class="md-list-item-text" @click="goToDownload()">Baixar App</span>
                    </md-list-item>
                    <!--md-list-item style="cursor: pointer;">
                        <md-icon style="color: white;margin-right: 0;">info</md-icon>
                        <span class="md-list-item-text" @click="dialogRegras()">Regulamento</span>
                    </md-list-item>
                    <md-list-item style="cursor: pointer;">
                        <span class="md-list-item-text" @click="live()">Ao Vivo</span>
                    </md-list-item-->
                    <md-list-item v-for="dia in diasFiltro" v-bind:key="dia.data" style="cursor: pointer;">
                        <span class="md-list-item-text" @click="filterday(dia.data)">{{ dia.label }}</span>
                    </md-list-item>
                    <template v-for="pais in paises">
                        <md-list-item  style="cursor: pointer;">
                            <span v-on:click="setVisibility(pais)" class="md-list-item-text">{{ pais.nome }}</span>
                        </md-list-item>
                        <md-list-item v-if="pais.visible" v-for="campeonato in pais.campeonatos" v-bind:key="campeonato.id" style="cursor: pointer;">
                            <span class="md-list-item-text" style="margin-left: 10px; font-size: 90%;" @click="filter(campeonato.id)">{{ campeonato.nome }}</span>
                        </md-list-item>
                    </template>
                </md-list>
            </md-app-drawer>
            <md-app-content>
                <md-empty-state class="no-event-found"
                md-icon="sentiment_very_dissatisfied" v-if="!loadingEvents && dias.length == 0"
                :md-label="msg"
                md-description="Aguarde, em breve novos jogos estarão disponíveis.">
                </md-empty-state>
                <div class="md-layout md-alignment-center-center" v-if="loadingEvents">
                    <table>
                        <tr>
                            <td style="text-align: center;"><img class="titan-logo" :src="this.loadingGif" style="width: 90px;"> </td>
                        </tr>
                        <tr>
                            <td><img class="titan-logo2" :src="this.logSiteLoad" style="padding: 40px;max-height: 400px;width:400px;"> </td>
                        </tr>
                    </table>
                </div>
                <div class="md-layout" style="position: fixed; background-color: white; width: 100%;">
                    <div class="md-layout-item">
                        <div class="md-layout top-par" v-bind:class="{ hide: (loadingEvents || dias.length <= 0 || isResumeOpened || isDetailOpened) }">
                            <div class="md-layout">
                                <div class="md-layout-item md-size-33" style="padding-left: 5px;padding-top: 5px;">
                                    <div class="md-layout">
                                        <div class="md-layout-item">
                                            <money v-bind="money" v-model="value" class="resume-input" @keyup.native="refreshBottomBar()" style="text-align: center;"></money>
                                        </div>
                                    </div>
                                </div>
                                <div class="md-layout-item md-size-33" style="padding-top: 5px; padding-right: 5px; padding-left: 5px;">
                                    <input type="text" class="resume-input" :placeholder="cleanPossibleReturn" readonly="readonly"  style="text-align: center;">
                                </div>
                                <div class="md-layout-item md-size-33" style="padding-top: 6px;padding-right: 5px;">
                                    <div class="md-layout" style="background-color: #f9cc4c; border: 1px solid #FBFAFA; border-radius: 5px; text-align: center; line-height: 32px; width: 85%; float: right;">
                                        <div class="md-layout-item" style="color: #424242; font-size: 1em; padding-left: 2px; cursor: pointer; font-weight: bold;" @click="toggleResume">
                                            <div>Finalizar</div>
                                        </div>
                                        <div class="md-layout-item md-size-30">
                                            <div style="background-color: red; color: white; font-weight: bold; border: 1px solid black; border-radius: 10px; width: 90%;height: 90%;">{{ qtdEventos }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout top-par2" v-bind:class="{ hide: (loadingEvents || dias.length <= 0 || isResumeOpened || isDetailOpened) }">
                            <div class="md-layout">
                                <div class="md-layout-item md-size-95" style="padding-left: 5px; padding-top: 5px;">
                                    <input type="text" v-model="stringFilter" class="resume-input" placeholder="Busca de jogos por nome e campeonato" style="border-right: 0;border-top: 0;border-left: 0;border-radius: 0;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <titan-events style="overflow-y: auto;overflow-x: hidden; height: 100%;" v-bind:class="{ hide: (loadingEvents || dias.length <= 0 || isResumeOpened || isDetailOpened) }" :dias="dias" :selected="selected" :isLive="isLive" @select="setSelecteds" @eventDetail="detail($event)"></titan-events>
                
                <titan-resume v-bind:class="{ hide: (loadingEvents || !isResumeOpened) }" :value="value" :punter="punter" :selected="selected" @updateValue="updateValue($event)" @updatePunter="updatePunter($event)" @clearTicket="clearTicket()" @removeSelected="removeSelected($event)"></titan-resume>

                <titan-detail style="overflow-y: auto;overflow-x: hidden; height: 100%;" v-bind:class="{ hide: (loadingEvents || !isDetailOpened || isResumeOpened) }" :eventDetail="eventDetail" :selected="selected" @setSelecteds="setSelecteds($event)"
                ></titan-detail>
            </md-app-content>
        </md-app>
    </div>
</template>

<script>
    import axios from 'axios'
    import Vue from 'vue';
    import { Money } from 'v-money'
    import TitanEvents from './TitanEvents.vue'
    import TitanResume from './TitanResume.vue'
    import TitanDetail from './TitanDetail.vue'

    export default {
        name: 'TitanHome',
        components: {
            Money, TitanEvents, TitanResume, TitanDetail
        },
        data () {
            return {
                titulo: this.$root.$data.THEME.site_name,
                logoSite: this.$root.$data.THEME.logo_site,
                logSiteLoad: this.$root.$data.THEME.logo_site_load,
                loadingGif: this.$root.$data.THEME.loading_gif,
                isResumeOpened: false,
                isDetailOpened: false,
                consulta: false,
                regras: false,
                numeroBusca: "",
                diasFiltro: [],
                paises: [],
                config: {},
                menuVisible: false,
                loadingFilters: true,
                loadingEvents: true,
                dias: [],
                selected: [],
                msg: "",
                qtdEventos: 0,
                multiplier: 1,
                punter: "",
                value: 0.00,
                possibleReturn: 0.00,
                eventDetail: [],
                alert: false,
                msgAlert: "",
                loggedIn: false,
                carregarPreAposta: false,
                numeroPreAposta: "",
                limites: null,
                isLive: false,
                stringFilter: "",
                money: {
                  decimal: ',',
                  thousands: '.',
                  prefix: 'R$ ',
                  precision: 2,
                  masked: false
                }
            }
        },
        watch:{
            stringFilter (val) {
                var filter = val.toLowerCase()

                for (var i = 0; i < this.dias[0].campeonatos.length; i++) {
                    var campeonato = this.dias[0].campeonatos[i];
                    if (filter == "" || campeonato.nome.toLowerCase().indexOf(filter) !== -1) campeonato.visible = true
                    else campeonato.visible = false

                    Vue.set(this.dias[0].campeonatos, i, campeonato)

                    for (var x = 0; x < campeonato.eventos.length; x++) {
                        var evento = campeonato.eventos[x]
                        if (filter == "" || evento.casa.toLowerCase().indexOf(filter) !== -1 || evento.fora.toLowerCase().indexOf(filter) !== -1) this.dias[0].campeonatos[i].eventos[x].visible = true
                        else this.dias[0].campeonatos[i].eventos[x].visible = false                     
                    }
                }
                //console.log(this.dias[0].campeonatos)
                // return this.dias
            }
        },
        methods: {
            setup: function() {
                for (let i = 0; i < this.paises.length; i++) {
                    let pais = this.paises[i];
                    pais.visible = false;
                    this.paises.splice(i, 1, pais);
                }
            },
            setVisibility: function(pais) {
                for (let i = 0; i < this.paises.length; i++) {
                    if (this.paises[i].nome == pais.nome) {
                        pais.visible = !pais.visible;

                        this.paises.splice(i, 1, pais);
                    }
                }
            },
            setSelecteds: function(selected) {
                this.selected = selected
                this.refreshBottomBar()
            },
            toggleResume: function() {
                this.isResumeOpened = !this.isResumeOpened
                this.changeTitle();
            },
            backHome: function(){
                this.isDetailOpened = false
                this.isResumeOpened = false 
                this.changeTitle()
            },
            changeTitle: function(){
                if (this.isResumeOpened) this.titulo = 'Resumo'
                else if (this.isDetailOpened) this.titulo = this.eventDetail.campeonato + ' - ' + this.eventDetail.nomeEvento
                else this.titulo = this.$root.$data.THEME.site_name
            },
            refreshBottomBar: function() {
                this.qtdEventos = this.selected.length

                var pr;
                var max_quote = parseFloat(this.config.max_quote)
                var top_prize = parseFloat(this.config.top_prize)
                var value = parseFloat(this.value)

                if (this.qtdEventos <= 0) {
                    pr = 0.0.toFixed(2)
                }
                else {
                    this.multiplier = 1;
                    for (let i = 0; i < this.qtdEventos; i++) {
                        this.multiplier = this.multiplier * (this.selected[i].cotacao/100)
                    }

                    pr = (this.multiplier * this.value).toFixed(2)
                }

                pr = parseFloat(pr)

                if (pr > value * max_quote) {
                    this.msgAlert = "Cotação máxima de " + max_quote + " vezes o valor apostado foi atingida."
                    pr = value * max_quote
                    this.alert = true
                }
                
                if (parseFloat(pr) > top_prize) {
                    this.msgAlert = "O limite de premiação de " + top_prize + " foi atingido."
                    pr = top_prize
                    this.alert = true
                }

                this.possibleReturn = pr
            },
            removeSelected: function(subevento) {
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i].id == subevento.id) {
                        this.selected.splice(i, 1);
                        break;
                    }
                }
                this.refreshBottomBar()
            },
            updatePunter: function(punter) {
                this.punter = punter
            },
            updateValue: function(value) {
                this.value = value
                this.refreshBottomBar();
            },
            clearTicket: function() {
                this.selected = []
                this.refreshBottomBar()
            },
            filter: function(param) {
                this.loadingEvents = true;
                this.isLive = false
                this.menuVisible = false
                this.dias = []
                const config = { headers: { 'content-type': 'multipart/form-data' } }
                const formData = new FormData()
                formData.append('json', '{"ids":['+param+']}')
                axios
                .post(this.$root.$data.API_URL + 'filter', formData, config)
                .then(response => {
                    if (response.status == 200) {
                        this.buildDias(response.data.eventos)
                    } else this.msg = response.statusText
                })
                .finally(() => this.loadingEvents = false );
            },
            filterday: function(param) {
                this.loadingEvents = true;
                this.isLive = false
                this.menuVisible = false
                this.dias = []
                const config = { headers: { 'content-type': 'multipart/form-data' } }
                const formData = new FormData()
                formData.append('json', '{"dia":"'+param+'"}')
                axios
                .post(this.$root.$data.API_URL + 'filterday', formData, config)
                .then(response => {
                    if (response.status == 200) {
                        this.buildDias(response.data.eventos)
                    } else this.msg = response.statusText
                })
                .finally(() => this.loadingEvents = false );
            },
            detail: function(event_id) {
                // this.loadingEvents = true
                this.eventDetail = []
                this.isDetailOpened = true;
                this.trackDetail(event_id)
            },
            dialogConsulta: function() {
                this.menuVisible = false
                this.consulta = true
            },
            dialogRegras: function() {
                this.menuVisible = false
                this.regras = true
            },
            dialogPreAposta: function() {
                this.menuVisible = false
                this.carregarPreAposta = true
            },
            consultar: function() {
                if (this.numeroBusca != "") {
                    this.$router.push({ name: 'TitanReprint', params: { id: this.numeroBusca }})
                }
            },
            goToLogin: function() {
                this.$router.push({ name: 'TitanLogin' })
            },
            concordoRegras: function() {
                this.regras = false
            },
            goToDownload: function() {
                window.location = "https://files.sportingplay.info/app-arena-online.apk"
            },
            buildDias: function(data) {
                this.dias = Object.keys(data).map((key) => {
                    //console.log(data[key]);
                    
                    return data[key]
                });

                this.dias[0].campeonatos = Object.keys(this.dias[0].campeonatos).map((key) => {
                    return this.dias[0].campeonatos[key];
                });
                
                /* Removendo Sort, objeto já vem ordenado da API
                this.dias[0].campeonatos.sort(function(a, b) {
                    if (a.nome > b.nome) return 1;
                    else if (a.nome < b.nome) return -1;
                    else return 0;
                })*/

                var mains = []
                var normals = []
                for (let i = 0; i < this.dias[0].campeonatos.length; i++) {
                    this.dias[0].campeonatos[i].visible = true
                    if (this.dias[0].campeonatos[i].main == 's') mains.push(this.dias[0].campeonatos[i])
                    else normals.push(this.dias[0].campeonatos[i])
                }

                for (let i = 0; i < normals.length; i++) {
                    mains.push(normals[i])
                }
                this.dias[0].campeonatos = mains
            },
            logout: function() {
                this.$store.commit('LOGOUT')
                this.loggedIn = false
            },
            goToMyTickets: function() {
                this.$router.push({ name: 'TitanMyTickets' })
            },
            goToMyCashflow: function() {
                this.$router.push({ name: 'TitanCashflow' })
            },
            carregar: function() {
                if (this.numeroPreAposta != "") {
                    let pre = {}
                    pre.eticket = this.numeroPreAposta

                    var form = new FormData();
                    form.append("token", this.$store.state.usuario.token);
                    form.append("json", JSON.stringify(pre));

                    var config = {
                      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                    };

                    let v = this
                    //seller/loadprebet
                    axios.post(this.$root.$data.API_URL + 'pdv/eticket', form, config)
                    .then(function (response) {
                        //console.log(response.data);
                        let result = response.data
                        if (result.codResposta == '000') {
                            let subevents = []
                            let bet_odds = result.carrinho.itens
                            for (let i = 0; i < bet_odds.length; i++) {
                                let s1 = bet_odds[i]

                                let subevento = {}
                                subevento.aposta = s1.nomeEvento
                                subevento.cotacao = s1.cotacao
                                subevento.dia = s1.schedule
                                subevento.fulllabel = s1.name
                                subevento.id = s1.idSubEvento
                                subevento.idOpcao = s1.idOpcao
                                subevento.label = s1.resultado
                                subevento.nomeSubevento = s1.nomeSubevento
                                subevento.titulo = s1.resultado

                                subevento.evento = {}
                                subevento.evento.nome = s1.nomeEvento
                                subevento.evento.casa = s1.home
                                subevento.evento.fora = s1.out
                                subevento.evento.schedule = s1.momentoEvento

                                subevents.push(subevento)
                            }

                            //v.updatePunter(result.result.punter)
                            v.updateValue(result.carrinho.totalPago/100)
                            v.setSelecteds(subevents)
                            v.isResumeOpened = true
                        } else {
                            v.msgAlert = result.mensagem
                            v.alert = true
                        }
                    })
                }
                else {
                    this.msgAlert = "Número da pré-aposta inválido."
                    this.alert = true
                }
            },
            refreshLimits: function() {
                var config = {
                  headers: {Authorization: 'Bearer  ' + this.$store.state.usuario.token}
                };

                axios
                .get(this.$root.$data.API_URL + 'seller/refreshpunter', config)
                .then(response => {
                    this.limites = response.data.punter.limits
                });
            },
            live: function() {
                this.loadingEvents = true
                this.isLive = true
                this.menuVisible = false
                this.trackLive()
            },
            loadLive: function(){
                axios
                .get(this.$root.$data.API_URL + 'live')
                .then(response => {
                    if (response.data.success) {
                        this.buildDias(response.data.result.eventos)
                    } else this.msg = response.data.message
                })
                .finally(() => this.loadingEvents = false );
            },
            trackLive() {
                if (!(this.isLive)) return false;

                var t = this
                t.loadLive()
                setTimeout(function() {
                    t.trackLive()
                }, 30000);
            },
            trackDetail(event_id) {
                this.loadDetail(event_id)

                if (!(this.isLive)  || !(this.isDetailOpened)) return false;

                var t = this
                setTimeout(function() {
                    t.trackDetail(event_id)
                }, 30000);  
            },
            loadDetail: function(event_id) {
                var t = this
                axios
                .get(this.$root.$data.API_URL + (this.isLive ? 'live/' : 'eventos/') + event_id)
                .then(response => {
                    t.eventDetail = response.data
                    t.changeTitle()
                    t.loadingEvents = false
                });
            },
            msgMudanca: function() {
                this.msgAlert = "A partir de agora o site LíderSports passa a ser<br><br> <a style='font-size: 125%; color: red;' href='http://www.arenaonline.bet/' target='_blank'>http://www.arenaonline.bet/</a><br>"
                this.alert = true
            }
        },
        mounted() {

            if (this.$store.state.usuario) {
                this.loggedIn = true
                //this.refreshLimits();
            }

            this.refreshBottomBar();
            axios
            .get(this.$root.$data.API_URL + 'eventos')
            .then(response => {
                //console.log(response.data.eventos);
                
                if (response.data.eventos) {
                    this.diasFiltro = response.data.dias.filtros
                    this.paises = response.data.campeonatos.modalidades['0'].paises
                    this.buildDias(response.data.eventos)
                } else {
                    this.msg = response.data.message; 
                    //console.log('a');
                }
                
            })
            .finally(() => this.loadingEvents = false );
            
            //Filtro removido pois dados já estão na primeira consulta
            /*axios
            .get(this.$root.$data.API_URL + 'filter')
            .then(response => {
                if (response.data.success) {
                    this.diasFiltro = response.data.result.dias.filtros
                    this.paises = response.data.result.campeonatos.modalidades['0'].paises
                    this.config = response.data.result.configs
                }
            }).finally(() => this.setup() );*/

            //this.msgMudanca()
        },
        computed: {
            cambista: function () {
              return this.$store.state.usuario
            },
            cleanPossibleReturn: function () {
                if (this.possibleReturn > 0) return "R$ " + this.possibleReturn;
                else return "R$ 0,00";
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
    primary: #000000, // The primary color of your brand
    accent: #226DA7 // The secondary color of your brand
    ));

@import "~vue-material/dist/theme/all"; // Apply the theme
</style>
